<template>
  <section class='page-socialEntertainment'>
    <resolution :current="socialEntertainment"/>
    <div>
      <a :href="siteUrl" class="experience-btn" target="_blank">
        <span>立即体验</span>
      </a>
    </div>
  </section>
</template>

<script>
import resolution from './index.vue'
import { CONSOLE_SITE_URL } from '@/utils/constants';

export default {
  metaInfo: {
  title: '娱乐社交解决方案__线上聊天室-马兰头医学科技',
  meta: [
    {
      name: 'keywords',
      content: '娱乐社交解决方案，线上相亲，游戏聊天，直播带货，直播答题，视频社交解决方案'
    },
    {
      name: 'description',
      content: '基于马兰头医学科技音视频互动+IM SDK的娱乐社交解决方案,支持互动连麦、在线相亲、游戏聊天、电商直播、等多种社交场景开发'
    },
  ]
  },
  name: 'socialEntertainment',
  components: {
    resolution
  },
  data () {
    return {
      siteUrl: CONSOLE_SITE_URL,
      socialEntertainment: {
        whyChoose: true,
        strength: {
          isGrey: true,
          title: '我们的优势',
          subtitle: '一站式解决方案，社交娱乐新玩法',
          content: [{
            title: '一站式解决方案',
            intro: '实时音视频+IM即时通讯整体解决方案，支持主流平台开播、观看及连麦互通',
            img: require('@/assets/resolution/socialEntertainment/icon1.png')
          },{
            title: '多样互动方式',
            intro: '直播、视频、连麦、消息互动。全套互动体验',
            img: require('@/assets/resolution/socialEntertainment/icon2.png')
          },{
            title: '高品质音画质量',
            intro: '1080P，60FPS，48kHz全频带音频编码，优秀的音频3A算法，保证良好的视频通话质量',
            img: require('@/assets/resolution/socialEntertainment/icon3.png')
          },{
            title: '结合AR/VR技术',
            intro: '可接入 AR /VR眼镜等设备，以第一视角呈现眼前景象。使游戏体验、远程社交更真实',
            img: require('@/assets/resolution/socialEntertainment/icon4.png')
          },]
        },
        banner: {
          title: '娱乐社交解决方案',
          desc: '互动新玩法，社交生活更加丰富多彩',
          image: require('@/assets/resolution/socialEntertainment/banner_img.png'),
          buttonText: '立即体验',
          buttonCallback: () => {
            window.open(CONSOLE_SITE_URL);
          }
        },
        use: {
          title: '使用场景',
          subtitle: '连麦、直播、实时互动。沟通零距离',
          content: [{
            title: '连麦PK',
            subtitle: '游戏、娱乐社交等场景下主播连麦PK，百万人同时在线互动',
            img: require('@/assets/resolution/socialEntertainment/case1.png')
          }, {
            title: '游戏聊天室',
            subtitle: '适用于游戏房间聊天、狼人杀。智能降噪，营造沉浸式游戏氛围',
            img: require('@/assets/resolution/socialEntertainment/case2.png')
          }, {
            title: '在线相亲会',
            subtitle: '红娘牵线，多方互动，多种在线相亲，观众嘉宾零距离',
            img: require('@/assets/resolution/socialEntertainment/case3.png')
          }, {
            title: '直播带货',
            subtitle: '高互动直播体验，支持亿万级大并发。更少的带宽流量消耗，更多的社交流量流入',
            img: require('@/assets/resolution/socialEntertainment/case4.png')
          }]
        },
      }
    }
  },
}
</script>

<style lang='less'>
.page-socialEntertainment {
  .experience-btn {
    text-align: center;
    display: block;
    margin-bottom: 40px;
    span {
      background: linear-gradient(325deg,#3b71f2 7%, #8da8ff 95%);
      border-radius: 25px;
      color: #ffffff;
      font-size: 18px;
      display: inline-block;
      cursor: pointer;
      padding: 12px 35px;
    }

  }
}
</style>
